<p>fake-step-one works!</p>
<button (click)="testClick()">test</button>
<button (click)="testClick()">test</button>
<button (click)="testClick()">test</button>


